/* eslint-disable @typescript-eslint/no-use-before-define */
import type { ReactNode } from 'react';
import React from 'react';
import { GroupItem, SimpleItem } from '@nuvolo/nuux-core/components/NuvoForm';
import type { IItemProps } from 'devextreme-react/form';

const renderGroup = ({ items: childItems, ...item }: IItemProps, i: number) => (
  <GroupItem key={`${item.caption}${i}`} {...item}>
    {renderItems((childItems as IItemProps[]) || [])}
  </GroupItem>
);

const renderSimpleItem = (item: IItemProps, i: number) => (
  <SimpleItem key={`${item.dataField}${i}`} {...item} />
);

const renderItem = (item: IItemProps, i: number): ReactNode => {
  if (item.itemType === 'group') {
    return renderGroup(item, i);
  }
  if (item.itemType === 'simple') {
    return renderSimpleItem(item, i);
  }
  return null;
};

const renderItems = (items: IItemProps[]) => {
  return items.map(renderItem);
};

export default renderItems;
